import { combineReducers } from 'redux';
import testrunner from './testrunner'

export default combineReducers({
  testrunner
})
